<template lang="pug">
.v-set-slider.set-slider(v-if="slider")
	.set-slider__container.container
		.set-slider__wrap
			.set-slider__header
				img.set-slider__icon(v-if="slider.icon" :src="slider.icon" alt="" loading="lazy")
				h2.set-slider__title(v-if="slider.title") {{slider.title}}
			.set-slider__slider-wrapper.flc(v-if="slider.items && slider.items.length")
				button.set-slider__arrow.set-slider__arrow--prev(type="button"
						ref="arrow-prev"
						aria-label="Предыдущий слайд")
					v-svg-icon.product-slider__arrow-icon(icon="chevron-left")
				button.set-slider__arrow.set-slider__arrow--next(type="button"
						ref="arrow-next"
						aria-label="Следующий слайд")
					v-svg-icon.product-slider__arrow-icon(icon="chevron-right")
				v-swiper-slider.set-slider__slider(:options="options"
						:navigation="navigation"
						allow-touch-move
						@swiper="onSwiper")
					swiper-slide.set-slider__slide(v-for="(item, index) in slider.items" :key="index")
						.set-slider__favorite-action
							v-favorite-action(:id="item.id" :name="item.name" :model="item.model")
						v-product(:product="item" size="sm")
			.set-slider__action.flc(v-if="slider.link")
				a.set-slider__btn(:href="slider.link.link"
						:class="slider.link.className") {{slider.link.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from "../scripts/breakpoints.js"
import {SwiperSlide} from "swiper/vue";

export default {
	mixins: [
		sourceMixin
	],

	components: {
		SwiperSlide,
	},

	data() {
		return {
			slider: null,
			options: {
				slidesPerView: 'auto',
				spaceBetween: 5,
				loop: true,
				breakpoints: {
					[breakpoints['sm-min']]: {
						spaceBetween: 32,
					}
				},
			},
			pagination: {
				clickable: false,
			},
			navigation: false
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs["arrow-prev"],
				nextEl: this.$refs["arrow-next"],
			};
		},

		dataSet(data) {
			this.slider = data;
		}
	}
};
</script>